import { useMutation, useQueryClient } from '@tanstack/react-query'

import { TasksService } from '@/services/tasks.service'

import { IRenameTaskRequest } from '@/types/task.interface'

export const useRenameTask = () => {
	const queryClient = useQueryClient()

	const { mutateAsync: renameTask, isLoading: isRenameTaskLoading } =
		useMutation({
			mutationKey: ['renameTask'],
			mutationFn: (data: IRenameTaskRequest) => TasksService.renameTask(data),
			onSuccess: async () => {
				await queryClient.invalidateQueries({ queryKey: ['getTasks'] })
			}
		})

	return {
		renameTask,
		isRenameTaskLoading
	}
}
